module.exports = __webpack_public_path__ + "img/ennetix-flows.9a8fd98b.png";